import React, { useState } from "react";
import { TextField, Button, Box } from "@mui/material";
import { Lead, ProcessedLeadDto } from "../types/LeadBoardTypes";

interface ProcessedLeadFormProps {
  lead: Lead | null;
  processedLead: ProcessedLeadDto;
  onSubmit: (data: any) => void;
}

const ProcessedLeadForm: React.FC<ProcessedLeadFormProps> = ({
  lead,
  processedLead,
  onSubmit,
}) => {
  const [formData, setFormData] = useState<any>({
    leadId: lead?.id,
    company: lead?.company || null,
    address: processedLead?.address || null,
    city: lead?.city || null,
    state: processedLead?.state || null,
    zip: processedLead?.zip || null,
    contactName: processedLead?.contactName || null,
    directPhone: processedLead?.directPhone || null,
    email: processedLead?.email || null,
    fax: processedLead?.fax || null,
    powerUnits: processedLead?.powerUnits || null,
    trailerUnits: processedLead?.trailerUnits || null,
    date: new Date().toISOString(),
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    onSubmit(formData);
  };

  return (
    <Box component="form" sx={{ display: "flex", flexDirection: "column" }}>
      <TextField
        name="company"
        label="Company"
        value={formData.company}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        name="powerUnits"
        label="Power Units"
        value={formData.powerUnits}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        name="trailerUnits"
        label="Trailer Units"
        value={formData.trailerUnits}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        name="address"
        label="Address"
        value={formData.address}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        name="city"
        label="City"
        value={formData.city}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        name="state"
        label="State"
        value={formData.state}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        name="zip"
        label="Zip"
        value={formData.zip}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        name="contactName"
        label="Contact Name"
        value={formData.contactName}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        name="directPhone"
        label="Direct Phone"
        value={formData.directPhone}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        name="fax"
        label="Fax"
        value={formData.fax}
        onChange={handleChange}
        margin="normal"
      />
      <TextField
        name="email"
        label="Email"
        value={formData.email}
        onChange={handleChange}
        margin="normal"
      />

      <Button variant="contained" onClick={handleSubmit}>
        Submit
      </Button>
    </Box>
  );
};

export default ProcessedLeadForm;
